import styled from "styled-components";

export const TodosListWrapper = styled.div`
  margin-top: 1.6rem;
  background: var(--element-bg);
  border-radius: 0.5rem;
  box-shadow: -1px 2px 17px -5px var(--card-shadow);
`;

export const TodosItems = styled.ul`
  width: 100%;
  height: 100%;
  list-style: none;
`;
